import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

// Sky DS ICON buttons (figma header @1024/768/375): UI Elements/Primary
// surface, r8, primaryHover on hover/focus/press, 16px gap.
const useStyles = makeStyles()((theme) => ({
  buttons: {
    ...dFlex(),
    gap: 16,
  },
  button: {
    padding: 6,
    width: 44,

    '&.MuiButton-contained': {
      background: theme.palette.custom.elements.primary,

      '&:hover, &:focus-visible, &:active': {
        background: theme.palette.custom.buttons.primaryHover,
      },
    },
  },
}));

export default useStyles;
